import { focusRing } from '../../theme/tokens'

// Phones: 52px, 16px in from the edges. 720px up (where the booking
// screen's phone bar goes too): 56px, 24px in. Both clear of the notch and
// the home indicator. Under the booking bar (90), every MUI Dialog/Drawer
// (1300) and Stripe's 3DS frame, so it never sits on top of them.
export const styles = {
  fab: {
    position: 'fixed',
    right: 'calc(var(--space-16) + env(safe-area-inset-right))',
    bottom: 'calc(var(--space-16) + env(safe-area-inset-bottom))',
    zIndex: 80,
    width: 52,
    height: 52,
    borderRadius: '50%',
    background: 'var(--whatsapp)',
    color: 'var(--on-accent)',
    boxShadow: 'var(--shadow-max)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:focus-visible': focusRing,
    '@media (min-width: 720px)': {
      width: 56,
      height: 56,
      right: 'calc(var(--space-24) + env(safe-area-inset-right))',
      bottom: 'calc(var(--space-24) + env(safe-area-inset-bottom))'
    }
  },
  // Booking screen on a phone: the sticky bar (total + next step) and then
  // the pay buttons own the bottom of the screen, so the button stands down.
  offOnPhone: {
    '@media (max-width: 719.98px)': {
      display: 'none'
    }
  },
  icon: {
    fontSize: 30
  },
  // CHAT_ENTRY=webchat: the button is the website chat's, in ink (the
  // primary fill), not WhatsApp's green.
  chat: {
    background: 'var(--ink)',
    color: 'var(--on-ink)',
    '&:hover': { background: 'var(--ink-hover)' }
  },
  chatIcon: {
    fontSize: 26
  }
}
